import { extendObservable } from 'mobx'
import { employeeApi } from '@atheneum/api'

class EmployeeStore {
  constructor () {
    extendObservable(this, {
      profile: null,
      loading: false
    })
  }

  getProfile = id => {
    this.loading = true

    return employeeApi
      .get(id)
      .then(profile => {
        this.profile = profile
        this.loading = false
        return profile
      })
      .catch(error => {
        console.error(error)
        this.error = error
        this.loading = false
      })
  }

  update (profileData) {
    return employeeApi.updateEmployee(profileData)
  }
}

export default EmployeeStore
